import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { CalendarComponent } from './calendar-component';

export const CalendarModule: string = ng
    .module('calendar-component', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('calendarComponent', CalendarComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/calendar/calendar-component.module.ts